/**
 * Evita `JSON.parse` em corpo vazio ou só espaços (ex.: respostas HTTP sem body),
 * que no browser dispara `SyntaxError: Unexpected end of JSON input`.
 */
export function tryParseJson<T>(raw: string | null | undefined): T | null {
  if (raw == null) return null
  const s = raw.trim()
  if (!s) return null
  try {
    return JSON.parse(s) as T
  } catch {
    return null
  }
}
